export default __webpack_public_path__ + "static/media/number2.d903b6c3.svg";